import React, { useContext, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { SelectionContext } from "../../Context/Store";
import DashboardView from "./DashboardView";

const Billing = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const isVendor = user?.userType === "Vendor";

  const { billingBalance, billingLoading, refreshBillingBalance } = useContext(
    SelectionContext
  );

  useEffect(() => {
    if (isVendor) refreshBillingBalance();
  }, [isVendor, refreshBillingBalance]);

  if (!isVendor) {
    return (
      <div className="p-4 text-center text-muted">
        Billing is only available on vendor accounts.
      </div>
    );
  }

  if (billingLoading && !billingBalance) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return <DashboardView balance={billingBalance} />;
};

export default Billing;
